module.exports = __webpack_public_path__ + "img/tuceng1.7e3872ec.png";